module.exports = __webpack_public_path__ + "static/media/ic-prev-stop-arrow-enabled.d461d5e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-prev-stop-arrow-enabled.svg
// module id = 421
// module chunks = 0